var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconUserAnaly(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "icon_user-analy",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\uC0AC\\uAC01\\uD615_1010",
    fill: "none",
    d: "M0 0H24V24H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1070",
    transform: "translate(-2 -3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_1069",
    transform: "translate(2 4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_715",
    d: "M10.8 13.778a4.844 4.844 0 0 0 4.8-4.889 4.8 4.8 0 1 0-9.6 0 4.844 4.844 0 0 0 4.8 4.889zm0-7.333a2.445 2.445 0 1 1-2.4 2.444 2.43 2.43 0 0 1 2.4-2.445z",
    className: "cls-2",
    transform: "translate(-1.2 -4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_716",
    d: "M4.4 18.888c.264-.88 3.972-2.444 7.2-2.444a7.387 7.387 0 0 1 .42-2.432C8.744 13.889 2 15.551 2 18.888v2.444h11.448a7.209 7.209 0 0 1-1.428-2.444z",
    className: "cls-2",
    transform: "translate(-2 -1.777)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_717",
    d: "M20.916 19.358a4.788 4.788 0 0 0 .684-2.469 4.8 4.8 0 1 0-4.8 4.889 4.686 4.686 0 0 0 2.424-.7l3.084 3.141L24 22.5c-1.8-1.834-.948-.979-3.084-3.142zm-4.116-.025a2.445 2.445 0 1 1 2.4-2.444 2.43 2.43 0 0 1-2.4 2.444z",
    className: "cls-2",
    transform: "translate(0 -2.222)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUserAnaly);
export default __webpack_public_path__ + "static/media/icon-user-analy.406e95d5.svg";
export { ForwardRef as ReactComponent };